import React, { useState, useRef } from 'react';
import { makeStyles } from '@mui/styles';
import {
	Paper,
	ButtonGroup,
	Button,
	ClickAwayListener,
	Popper,
	MenuItem,
	MenuList
} from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { indexOf } from 'lodash';

const useStyles = makeStyles(() => ({
	noBorder: {
		borderRadius: '0px'
	}
}));

export const FilterSelect = ({ options, setFilter, value }) => {
  const classes = useStyles();
  const anchorRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);

  React.useEffect(() => {
    if (value !== options[selectedIndex]) {
      if (value) {
        setSelectedIndex(indexOf(options, value));
      } else {
        setSelectedIndex(0);
      }
    }
  }, [value]);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
	};
  
  const handleMenuItemClick = (event, index) => {
    setSelectedIndex(index);
		setOpen(false);
		if (index !== 0) {
			setFilter(options[index]);
		} else {
			setFilter();
		}
  };

  return (
    <div>
      <ButtonGroup size="small" ref={anchorRef}>
        <Button onClick={handleToggle} className={classes.noBorder}>{options[selectedIndex]}</Button>
        <Button
          color="primary"
          size="small"
          aria-controls={open ? 'split-button-menu' : undefined}
          aria-expanded={open ? 'true' : undefined}
          aria-label="select merge strategy"
          aria-haspopup="menu"
          onClick={handleToggle}
          className={classes.noBorder}
        >
          <ArrowDropDownIcon />
        </Button>
      </ButtonGroup>

			<Popper open={open} anchorEl={anchorRef.current} role={undefined} disablePortal className="options">
				<Paper>
					<ClickAwayListener onClickAway={handleClose}>
						<MenuList id="split-button-menu">
							{options.map((option, index) => (
								<MenuItem
									key={option}
									selected={index === selectedIndex}
									onClick={(event) => handleMenuItemClick(event, index)}
								>
									{option}
								</MenuItem>
							))}
						</MenuList>
					</ClickAwayListener>
				</Paper>
       </Popper>

    </div>
  );
};
